import store from 'store';

export function getInsuranceCardWasSkipped(): boolean {
  return store.get('InsuranceCardWasSkipped') === 'true';
}

export function setInsuranceCardWasSkipped(wasSkipped: boolean) {
  store.set('InsuranceCardWasSkipped', wasSkipped.toString());
  const event = window.document.createEvent('Event');
  event.initEvent('storage', true, true);
  window.dispatchEvent(event);
}
